var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-wizard-field-priority" },
    [
      _c(
        "CompassFormItem",
        _vm._b({}, "CompassFormItem", _vm.formItemProps, false),
        [
          _c("CompassIconButton", {
            class: _vm.iconClass,
            attrs: { icon: _vm.icon },
            on: { click: _vm.updatePriority }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }